// extracted by mini-css-extract-plugin
module.exports = {"container":"loginForm_container__1vyUV","checkbox":"loginForm_checkbox__Djue7","button":"loginForm_button__3kRBw","text":"loginForm_text__2_qv4","link":"loginForm_link__3DnuA"};